(() => {
  if (window.RisionBrandStoryV1) return;
  window.RisionBrandStoryV1 = true;

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

  const reveal = () => {
    const nodes = document.querySelectorAll('.rision-brand-reveal');
    if (!nodes.length || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach((node) => observer.observe(node));
  };

  const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);

  const updateHeroTitle = () => {
    document.querySelectorAll('.rision-brand-hero[data-scroll-title]').forEach((section) => {
      const rect = section.getBoundingClientRect();
      const total = Math.max(1, rect.height - window.innerHeight);
      const progress = easeOutCubic(clamp(-rect.top / (total * 0.78)));
      section.style.setProperty('--hero-title-opacity', progress.toFixed(3));
      section.style.setProperty('--hero-title-y', `${Math.round((1 - progress) * 60)}px`);
    });
  };

  const updateAbout = () => {
    document.querySelectorAll('.rision-brand-about').forEach((section) => {
      const rect = section.getBoundingClientRect();
      const total = Math.max(1, rect.height - window.innerHeight);
      const progress = clamp(-rect.top / (total * 0.78));
      section.style.setProperty('--about-progress', progress.toFixed(3));
    });
  };

  const setActive = (items, index) => {
    items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
  };

  const updateScrollStory = () => {
    document.querySelectorAll('.rision-brand-scroll-story').forEach((section) => {
      const count = Number(section.dataset.count || 1);
      if (count <= 1) return;

      const rect = section.getBoundingClientRect();
      const total = Math.max(1, rect.height - window.innerHeight);
      const progress = clamp(-rect.top / total);
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      const active = Math.min(count - 1, Math.floor(progress * count));
      const copyActive = isMobile
        ? Math.min(count - 1, Math.max(0, Math.floor(progress * count + 0.16)))
        : active;
      const mediaActive = isMobile
        ? Math.min(count - 1, Math.max(0, Math.floor(progress * count - 0.16)))
        : active;
      section.style.setProperty('--story-count', count);
      section.dataset.active = String(copyActive);

      setActive(section.querySelectorAll('[data-step-copy]'), copyActive);
      setActive(section.querySelectorAll('[data-step-media]'), mediaActive);
    });
  };

  const updateValuesCards = () => {
    document.querySelectorAll('.rision-brand-values--v3').forEach((section) => {
      const cards = section.querySelectorAll('[data-step-card]');
      const titleWrap = section.querySelector('.rision-brand-values__title-wrap');
      if (!cards.length) return;

      const rect = section.getBoundingClientRect();
      const total = Math.max(1, rect.height - window.innerHeight);
      const progress = clamp(-rect.top / total);
      const count = cards.length;
      const inActiveWindow = rect.top <= 0 && rect.bottom > window.innerHeight;
      section.classList.toggle('is-active', inActiveWindow);

      if (inActiveWindow && section.dataset.valuesTitleAnimated !== 'true') {
        section.dataset.valuesTitleAnimated = 'true';
        section.classList.add('has-title-animated');
      }

      if (titleWrap) {
        titleWrap.classList.toggle('is-hidden', progress > 0.22);
      }

      const cardStart = 0.20;
      const cardRange = 0.78;
      const step = cardRange / count;

      cards.forEach((card, i) => {
        const start = cardStart + step * i;
        const end = start + step + 0.02;
        const active = progress >= start && progress < end;
        card.classList.toggle('is-entered', progress >= start);
        card.classList.toggle('is-active', active);
      });
    });
  };

  const revealMobileValues = () => {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    const targets = document.querySelectorAll('.rision-brand-values--v3 .rision-brand-values__title-wrap, .rision-brand-values--v3 [data-step-card]');
    if (!targets.length) return;

    targets.forEach((target, index) => {
      target.style.setProperty('--mobile-values-delay', `${Math.min(index * 90, 360)}ms`);
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-mobile-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-mobile-visible');
        if (entry.target.classList.contains('rision-brand-values__title-wrap')) {
          const section = entry.target.closest('.rision-brand-values--v3');
          if (section && section.dataset.valuesTitleAnimated !== 'true') {
            section.dataset.valuesTitleAnimated = 'true';
            section.classList.add('has-title-animated');
          }
        }
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -10% 0px' });

    targets.forEach((target) => observer.observe(target));
  };

  const animateStats = () => {
    const stats = document.querySelectorAll('.rision-brand-team__stat');
    if (!stats.length || !('IntersectionObserver' in window)) return;

    const format = (el, value) => {
      const suffix = el.dataset.suffix || '';
      const prefix = el.dataset.prefix || '';
      el.textContent = prefix + value + suffix;
    };

    const parseTarget = (text) => {
      const match = String(text).match(/([0-9.,]+)/);
      return match ? parseFloat(match[1].replace(/,/g, '')) : 0;
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.target.dataset.counted === 'true') return;
        entry.target.dataset.counted = 'true';
        const el = entry.target;
        const strong = el.querySelector('strong');
        if (!strong) return;

        const suffixMatch = strong.textContent.match(/[^0-9.,\s]+/g);
        const suffix = suffixMatch ? suffixMatch.join('') : '';
        const target = parseTarget(strong.textContent);
        const decimals = Number.isInteger(target) ? 0 : 1;
        const duration = 2600;
        const start = performance.now();

        const step = (now) => {
          const elapsed = now - start;
          const t = Math.min(1, elapsed / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          const current = target * eased;
          strong.textContent = (decimals ? current.toFixed(decimals) : Math.round(current)) + suffix;
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });

    stats.forEach((stat) => observer.observe(stat));
  };

  let ticking = false;
  const update = () => {
    ticking = false;
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    updateHeroTitle();
    updateScrollStory();
    if (isMobile) return;
    updateAbout();
    updateValuesCards();
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  document.addEventListener('DOMContentLoaded', () => {
    reveal();
    update();
    revealMobileValues();
    animateStats();
  });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
})();
